import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { PayComponent } from './pay';
import { TemplateComponent } from './template';
import { ConfirmationComponent } from './confirmation';
import { AccountComponent } from './account';

import { AccountGuard } from './guards/account.guard';

const routes: Routes = [
   {
      path: 'confirmation/:number',
      component: ConfirmationComponent
   },
   {
      path: 'submit',
      canActivate: [ AccountGuard ],
      component: TemplateComponent
   },
   {
      path: 'pay',
      canActivate: [ AccountGuard ],
      component: PayComponent
   },
   {
      path: '',
      component: AccountComponent
   },

   { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [ RouterModule.forRoot( routes, {
     // enableTracing: true,
  })],
  exports: [ RouterModule ]
})
export class AppRouterModule { }
